import { render, staticRenderFns } from "./ModalDetalleComprobante.vue?vue&type=template&id=67bf091c&"
import script from "./ModalDetalleComprobante.vue?vue&type=script&lang=js&"
export * from "./ModalDetalleComprobante.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports